import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { StatusComponent } from "./status/status.component";
import { OnDemandComponent } from "./ondemand/ondemand.component";
import { ProductOnboardStatusComponent } from "./product-onboard-status/product-onboard-status.component";
import { ProductStatusTrackComponent } from "./product-status-track/product-status-track.component";
import { Roles, LionrockUserRoles } from "../npr-request.model";
import { PslComponent } from "./psl/psl.component";
import { SkipListComponent } from "./skip-list/skip-list.component";
import { RedirectToBetUiGuard } from "./redirect-to-bet-ui.guard";

const billingMeterRoutes = [
  {
    path: "prep/psl",
    url: "/prep/psl",
    component: PslComponent,
    name: "PSL Billing Meter",
    data: { title: "PSL Billing Meter" },
    Roles: [LionrockUserRoles.Administrator, Roles.BetPslLaunchLeader],
    canActivate: [RedirectToBetUiGuard],
  },
  {
    path: "prep/ondemand",
    url: "/prep/ondemand",
    component: OnDemandComponent,
    name: "On-Demand Billing Meter",
    data: { title: "On-Demand Billing Meter" },
    Roles: [LionrockUserRoles.Administrator, Roles.BetServiceOwner, LionrockUserRoles.RolePrefix + LionrockUserRoles.Administrator],
    canActivate: [RedirectToBetUiGuard],
  },
  {
    path: "prep/status",
    url: "/prep/status",
    component: StatusComponent,
    name: "Billing Meter Status",
    data: { title: "Billing Meter Status" },
    canActivate: [RedirectToBetUiGuard],
  },
  {
    path: "product-onboard-status",
    url: "/product-onboard-status",
    component: ProductOnboardStatusComponent,
    name: "New Product Launch Meter Status",
    data: { title: "New Product Launch Meter Status" },
    Roles: [LionrockUserRoles.Administrator, Roles.BetServiceOwner],
    canActivate: [RedirectToBetUiGuard],
  },
  {
    path: "prep/product-status-track",
    url: "/prep/product-status-track",
    component: ProductStatusTrackComponent,
    name: "Product Status Track",
    data: { title: "Product Status Track" },
    canActivate: [RedirectToBetUiGuard],
  },
  {
    path: "prep/skip-list",
    url: "/prep/skip-list",
    component: SkipListComponent,
    name: "Skip List",
    data: { title: "Skip List" },
    Roles: [LionrockUserRoles.Administrator, Roles.BetPslLaunchLeader],
    canActivate: [RedirectToBetUiGuard],
  },
];

const routes: Routes = [...billingMeterRoutes];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {
  static routes = routes;
  static billingMeterRouters = billingMeterRoutes;
}
